// extracted by mini-css-extract-plugin
export default {"root_cnt":"root_cnt___X3Yoj"};